import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { getDepartaments, getDepartamentsByIdCourses } from "../services/school/departament/getDepartaments";
import { PagedRequestType } from "../types/PagedResults";
export const useGetDepartamentsQuery = (data: PagedRequestType, options: any = null) => {
  const managerData = useSelector((state: RootState) => state.manager);
  return useQuery(
    ["departaments-pagination", JSON.stringify(data)],
    () => managerData
     && managerData?.idUser
     && managerData.isManager
     && managerData.departments
     && managerData.departments?.length > 0 ? getDepartaments(data).then(async (d) => {

      let filteredDepartaments = d.items.filter((faculty: any) =>
        managerData.departments?.some((d: any) => d === faculty.id)
      );
        if(managerData.courses && managerData.courses.length>0){
          const idsCourse = managerData.courses;
          let request = {PageNumber:1, PageSize:100, IdsCourses: idsCourse, IdFaculty: data.IdFaculty};
          const departaments = await getDepartamentsByIdCourses(request);
          filteredDepartaments =Array.from(new Set([...filteredDepartaments, ...departaments.items]))
        }

      return { ...d, items: filteredDepartaments }
    }) : getDepartaments(data),
    options ? { ...options } : {}
  );
};